import { render, staticRenderFns } from "./ConfirmPopups.vue?vue&type=template&id=807c93f8&"
import script from "./ConfirmPopups.vue?vue&type=script&lang=js&"
export * from "./ConfirmPopups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports